<mat-dialog-content>

  <section class="w3l-form-25">
    <div class="form-inner-cont">
        <div class="w3l-form-25">
            <h1>{{'Change password' | translate }}</h1>
        </div>
    </div>
    <form action="search-results.html"  method="get"  align="center">

        <img src="assets/images/change-password1.jpg"  alt="User Image" width="100px" height="130px" style="align-items: center;"/>

     </form>


    <div id="w3l-appointment">
      <div class="example-full-width" style="width: 100%;">
        <div class="styled-input">
          <div class="appointment-form-field">
              <label style="width: 30%;">{{'User ID' | translate}}</label>
              <span class="fa fa-search" style="cursor: grab;" aria-hidden="true" ></span>
              <input type="text" name="RoomID_1" id="RoomId_1" maxlength="3ch" placeholder="Room Code" [(ngModel)]="userid" disabled="true" style="width: 30%;">
          </div>
          <div class="appointment-form-field">
            <label style="width: 30%;">{{'Old Password' | translate}}</label>
            <span class="fa fa-search" style="cursor: grab;" aria-hidden="true" ></span>
            <input type="password" name="oldpassword" id="oldpassword"  placeholder="Old Password" [(ngModel)]="Oldpassword" (change)="retriveUserspasword()"  style="width: 50%;">
        </div>

        <div class="appointment-form-field">
          <label style="width: 30%;">{{'New Password' | translate}}</label>
          <span class="fa fa-search" style="cursor: grab;" aria-hidden="true" ></span>
          <input type="password" name="newpassword" id="newpassword" placeholder="New Password" [(ngModel)]="Newpassword" [disabled]="isDisabled"  style="width: 50%;">
        </div>

        <div class="appointment-form-field">
          <label style="width: 30%;">{{'Confirm Password' | translate}}</label>
          <span class="fa fa-search" style="cursor: grab;" aria-hidden="true" ></span>
          <input type="password" name="confirmpassword" id="confirmpassword" placeholder="Confirm Password" [(ngModel)]="confirmpassword" (change)="checknewpassword()" [disabled]="isDisabled"   style="width: 50%;">
        </div>

    </div>
    </div>

    <form style="text-align: center;">
      <button mat-raised-button style="width:25%;background-color:#0f7b0d;color: #fffffe; height: 50px; font-size: 85%;font-weight: bolder;" (click)="submitUsers()" >Save</button>
    </form>

  </div>

</section>

</mat-dialog-content>

